import { IRegion } from './region';


export interface IRegionState {
  readonly id: number;
  regionId?: number;
  region?: IRegion;
  code?: string;
  name?: string;
  state?: string;
}
